export interface WorkflowChildLinksRead {
  workflowId: number;
  occurrenceId: number;
  eTag: string;
  links: WorkflowChildLinkRead[];
}
export interface WorkflowChildLinkRead {
  id: string;
  code: string;
  label: string;
  mode: string;
  state: string;
  revision: number;
  childReference: string | null;
  childRoute: string | null;
  outcomeId: string | null;
  outcomeRevision: number | null;
  outcomeCode: string | null;
  outcomeLabel: string | null;
  isSatisfied: boolean;
  canConsume: boolean;
  issueCode: string | null;
}
export interface WorkflowChildConsumeRequest {
  occurrenceId: number;
  expectedETag: string;
  linkId: string;
  expectedRevision: number;
  expectedOutcomeId: string;
  expectedOutcomeRevision: number;
  reason: string;
}
export interface WorkflowChildConsumeResult {
  eTag: string;
  link: WorkflowChildLinkRead;
}
export function childWorkStateLabel(state: string): string {
  return (
    (
      {
        pending: 'Pending',
        running: 'Running',
        failed: 'Failed',
        completed: 'Completed',
        cancelled: 'Cancelled',
      } as Record<string, string>
    )[state] ?? 'Unavailable state'
  );
}
